import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Loader } from 'lucide-react';
export var ContainedButton = function ContainedButton(param) {
    var onClick = param.onClick, _param_label = param.label, label = _param_label === void 0 ? 'Click' : _param_label, _param_disabled = param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled;
    return /*#__PURE__*/ _jsx("button", {
        className: "border border-[var(--color-border-light-gray)] bg-white disabled:bg-gray-400 text-[var(--color-primary-bg)] rounded-full shadow-sm font-bold text-base leading-[1.5] min-w-[80px] h-[2.6rem] px-3 py-2 cursor-pointer transition-all duration-200 ease-in-out disabled:opacity-50 disabled:cursor-not-allowed",
        onClick: onClick,
        disabled: disabled,
        children: /*#__PURE__*/ _jsxs("div", {
            className: "flex items-center justify-center gap-1",
            children: [
                disabled && /*#__PURE__*/ _jsx(Loader, {
                    size: 20
                }),
                label
            ]
        })
    });
};
